/*
 * @Author: lzy
 * @Date: 19-10-25
 * @LastEditTime: 2021-05-19 15:41:26
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\baijiahao\baijiahao.js
 * @Description:  百家号渠道主模块
 */
angular
    .module('editingCenterBaijiahaoModule', [
        'editBaijiahaoLeftModule',
        'editBaijiahaoRouterModule',
        'editBaijiahaoToBeCompiledModule',
        'editBaijiahaoToBeCompiledNewsModule',
        'editBaijiahaoToBeCompiledAtlasModule',
        'editBaijiahaoToBeCompiledVideoModule',
        'editBaijiahaoPendingModule',
        'editBaijiahaoSignedModule',
        'editBaijiahaoDraftBoxModule',
        'baijiahaoServiceModule',
    ])
    .controller('EditingCenterBaijiahaoModule', ['$scope', function($scope) {}])
    .value('baijiaConst', {
        listenStroageKey: 'Baijiahao', // 监听缓存的名称
        // 百家号渠道常量（包括请求参数、完整渠道变量等常量）
        trial: {
            // 送审参数
            serviceid: 'mlf_baijiahaooper',
            methodname: 'trialBaiJiaHaoArticle',
        },
        sign: {
            // 签发参数
            serviceid: 'mlf_baijiahaooper',
            methodname: 'publishBaiJiaHaoArticle',
        },
        delete: {
            // 废稿参数
            serviceid: 'mlf_baijiahao',
            methodname: 'abolishBaiJiaHaoArticles',
        },
        exportDraft: {
            // 导出参数
            serviceid: 'mlf_baijiahao',
            methodname: 'exportWordFile',
        },
        draftListDB: {
            // 发稿单待编参数
            serviceid: 'mlf_appfgd',
            methodname: 'baiJiaHaoDaiBianbatchUpdateFgdUsers',
        },
        draftListDS: {
            // 发稿单待审参数
            serviceid: 'mlf_appfgd',
            methodname: 'baiJiaHaoDaiShenbatchUpdateFgdUsers',
        },
        draftListQuery: {
            // 发稿单查询参数
            serviceid: 'mlf_appfgd',
            methodName: 'queryFgdByBaiJiaHaoArticleId',
        },
        outSendingDraft: {
            // 邮件外发函数
            serviceid: 'mlf_baijiahao',
            methodname: 'sendEmail',
        },
        propagandaReview: {
            // 宣传部送审参数
            serviceid: 'mlf_baijiahaooper',
            methodname: 'trialByPropagandaDepartment',
        },
        drawNews: {
            // 撤稿参数
            serviceid: 'mlf_baijiahaooper',
            methodname: 'reTrialBaiJiaHaoArticle',
        },
        retraction: {
            // 取消签发函数
            serviceid: 'mlf_baijiahaooper',
            methodname: 'cancelBaiJiaHaoArticle',
        }
    });
